<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Gemma Bolger is a mother of four, who has only recently taken up writing as her children have gotten older. Gemma is married to Pat and they have recently celebrated their silver wedding anniversary. Living in rural Waterford, she enjoys the space and peace of her surroundings. Gemma runs a small engineering business with her husband but still manages to find time for her hobbies. As well as reading and creative writing, she loves to swim and sing – but not at the same time! Weather permitting, she does her best to be green-fingered and loses herself in gardening.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?019d9246